type FormatPriceOptions = {
  locale?: string;
  currency?: string;
  minimumFractionDigits?: number;
  maximumFractionDigits?: number;
  style?: 'currency' | 'decimal' | 'percent';
};

export function formatPrice (
  value: number,
  {
    locale = 'ru-KZ',
    currency = 'KZT',
    minimumFractionDigits = 0,
    maximumFractionDigits = 0,
    style = 'currency',
  }: FormatPriceOptions = {},
): string {
  return new Intl.NumberFormat(locale, {
    style,
    currency,
    minimumFractionDigits,
    maximumFractionDigits,
  }).format(value)
}
